module.exports = __webpack_public_path__ + "static/media/icon_playground_comment.5ecf6947.svg";